/*
  Sticky Live-Vorschau auf dem Handy (TeeinBlue).

  Basiert auf der TeeinBlue-Anleitung "Enable sticky gallery on mobile", mit drei
  Anpassungen an diesen Shop (alle am Live-Rendering gemessen, 2026-08-03):

  1) Selektor: `.tee-gallery-wrapper` statt `.grid__item.product__media-wrapper`.
     Die Klasse setzt TeeinBlue selbst an den Galerie-Slot -> das CSS bleibt auf
     allen anderen ~630 Produkten wirkungslos, statt sich auf einen frueh
     greifenden return zu verlassen.

  2) Andock-Schwelle: Die Vorlage rechnet mit der Hoehe des WRAPPERS. Der ist hier
     8.193 px hoch, weil TeeinBlue ihn ueber die ganze Infospalte spannt (fuer sein
     eigenes `position: sticky`). Damit waere `tFormBottom > stickyCondHeight` nie
     wahr und die Galerie wuerde nie andocken. Gerechnet wird deshalb mit der
     SICHTBAREN Galerie (`.tee-gallery`, 460 px) mal SCALE plus Innenabstand.

  3) Start: Polling auf die TeeinBlue-Elemente statt `setTimeout(..., 2000)` —
     das Vue-Formular rendert je nach Netz spaeter.

  4) Fixiert wird `.tee-gallery` (die sichtbare Vorschau, 460 px), NICHT
     `.tee-gallery-content` wie in der Vorlage. In diesem Shop sind
     `#tee-gallery` und `.tee-gallery-content` DASSELBE Element und tragen einen
     Inline-Style `height: <Formularhoehe>px` von TeeinBlue (gemessen 8.193 px).
     Fixiert man das, ist die Overlay-Flaeche 4.706 px hoch und der Zustand
     flackert - beides live beobachtet.

  Vorbedingung geprueft: kein Vorfahre der Galerie hat `transform`/`filter`,
  sonst wuerde `position: fixed` nicht am Viewport haften (Dawn-Falle).

  ⚠️ NICHT auf einem echten Geraet verifiziert: TeeinBlue schaltet sein Layout
  ueber `isMobileDevice()` (User-Agent), nicht ueber die Fensterbreite. Mit
  Desktop-User-Agent - also in jedem Testbrowser hier - baut TeeinBlue das
  Desktop-Galerie-Layout auf, waehrend das Theme die Spalten stapelt. Die
  Geometrie auf einem echten Handy ist eine andere.
*/
(function () {
  'use strict';

  /*
    Testmodus: solange true, greift die Funktion NUR mit ?stickygallery=1 in der URL.
    Am 03.08.2026 nach bestandenem Geraetetest (Andocken, X, Aussetzen bei
    Vorschau-Modal und Text-Editor) auf false gestellt -> fuer alle Kunden aktiv.
    Zum schnellen Abschalten wieder auf true setzen.
  */
  var TESTMODUS = false;

  var GALLERY_WRAPPER = '.tee-gallery-wrapper';
  var VISIBLE_GALLERY = '.tee-gallery';
  var SCALE = 0.7;
  var PADDING_Y = 20;
  var SAFETY_SCROLLING_RANGE = 100;

  function start() {
    var $gallery = document.querySelector(GALLERY_WRAPPER);
    var $visible = $gallery && $gallery.querySelector(VISIBLE_GALLERY);
    var $form = document.getElementById('tee-artwork-form');
    if (!$gallery || !$visible || !$form) return;

    /* Andock-Schwelle = Hoehe der eingeblendeten Vorschau (skaliert) + Innenabstand */
    var stickyCondHeight =
      ($visible.getBoundingClientRect().height || 0) * SCALE + PADDING_Y * 2;
    if (!stickyCondHeight) return;

    /*
      Drei Zustaende:
        gallery--sticky          = angedockt
        gallery--sticky--hide    = vom Kunden per X ausgeblendet (Kamera-Icon holt sie zurueck)
        gallery--sticky--suspend = ausgesetzt, solange ein TeeinBlue-Overlay offen ist
                                   (Vorschau-Modal, Text verschieben/skalieren). Ohne das
                                   laege die angedockte Vorschau UEBER dem Modal, weil der
                                   Wrapper z-index 9999 bekommt und TeeinBlues Dialog nur 999.
    */
    var AKTIV = '.gallery--sticky:not(.gallery--sticky--hide):not(.gallery--sticky--suspend) ';

    var style = document.createElement('style');
    style.innerHTML = [
      AKTIV + GALLERY_WRAPPER + ' { z-index: 9999; }',
      /*
        Fixiert wird die SICHTBARE Vorschau `.tee-gallery` (460 px) - NICHT
        `.tee-gallery-content`/`#tee-gallery` wie in der Vorlage. Auf diese
        beiden setzt TeeinBlue per Inline-Style eine Hoehe in Formularlaenge
        (gemessen: 8.193 px); fixiert man die, deckt die Overlay-Flaeche den
        halben Bildschirm ab und der Zustand flackert.
      */
      AKTIV + GALLERY_WRAPPER + ' ' + VISIBLE_GALLERY + ' {',
      '  background: #fff; display: flex; justify-content: center; left: 0; position: fixed;',
      '  top: 0; width: 100vw; z-index: 99; padding: ' + PADDING_Y + 'px 0;',
      '  transform: scale(' + SCALE + '); transform-origin: top center; }',
      AKTIV + GALLERY_WRAPPER + ' .tee-thumbnails,',
      AKTIV + GALLERY_WRAPPER + ' .tee-slider__dots { display: none; }',
      AKTIV + '.gallery--close-button { display: block; }',
      '.gallery--sticky.gallery--sticky--hide:not(.gallery--sticky--suspend) .sticky-gallery-button { display: block; }',
      /* Ausgesetzt: nichts von uns bleibt sichtbar */
      '.gallery--sticky--suspend .sticky-gallery-mask,',
      '.gallery--sticky--suspend .gallery--close-button,',
      '.gallery--sticky--suspend .sticky-gallery-button { display: none !important; }',
      '.sticky-gallery-button {',
      '  background: #fff no-repeat center; background-size: 20px 20px; border-radius: 50%;',
      '  box-shadow: 0 2px 5px 3px rgba(0,0,0,.15); display: none; height: 40px;',
      '  position: fixed; right: 20px; top: 100px; width: 40px; z-index: 999; cursor: pointer; }',
      /*
        Das X haengt an der UNTERKANTE der angedockten Vorschau, nicht am oberen
        Bildschirmrand: dort war es auf dem Handy oft ausserhalb des sichtbaren
        Bereichs, weil die Browserleiste beim Scrollen ein- und ausblendet und
        den visuellen Viewport verschiebt. `top` wird in updateMaskHeight gesetzt.
      */
      '.gallery--close-button {',
      '  background: #fff no-repeat center; background-size: 14px 14px; display: none;',
      '  height: 32px; width: 32px; border-radius: 50%; box-shadow: 0 1px 4px rgba(0,0,0,.25);',
      '  opacity: .9; position: fixed; right: 12px; top: 12px; z-index: 1000; cursor: pointer; }',
      '.sticky-gallery-mask {',
      '  position: fixed; top: 0; left: 0; width: 100vw; background: #fff;',
      '  box-shadow: 0 2px 5px 3px rgba(0,0,0,.15); z-index: 999; display: none; }',
      '.gallery--sticky--hide .sticky-gallery-mask { display: none !important; }'
    ].join('\n');
    document.head.appendChild(style);

    /* Icons als data-URI, damit kein zusaetzlicher Request noetig ist */
    var ICON_OPEN =
      "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\"/><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\"/><path d=\"M21 15l-5-5L5 21\"/></svg>')";
    var ICON_CLOSE =
      "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"black\" stroke-width=\"3\" stroke-linecap=\"round\"><path d=\"M4 4l16 16M20 4L4 20\"/></svg>')";

    var hasStickyButton = false;
    var hasCloseButton = false;
    var isSticky = false;
    var lastCheckScrollY = null;
    var maskEl = null;
    var closeBtnEl = null;
    var letzteOverlayHoehe = 0;
    var feldFokussiert = false;
    var fokussiertesFeld = null;
    var istAusgesetzt = false;
    var ABSTAND_UNTER_VORSCHAU = 12;

    function ensureMask() {
      if (maskEl) return;
      maskEl = document.createElement('div');
      maskEl.className = 'sticky-gallery-mask';
      document.body.appendChild(maskEl);
    }

    function updateMaskHeight(height) {
      ensureMask();
      letzteOverlayHoehe = height || 0;
      if (!height) {
        maskEl.style.display = 'none';
        maskEl.style.removeProperty('height');
        return;
      }
      maskEl.style.display = 'block';
      maskEl.style.height = height + 'px';
      syncOffsets();
    }

    /*
      Am SICHTBAREN Bereich ausrichten, nicht am Layout-Bereich.
      Auf Android liegt `position: fixed` am Layout-Viewport. Oeffnet sich die
      Tastatur, verschiebt sich der sichtbare Ausschnitt darin - die angedockte
      Vorschau landet dann oberhalb davon und ist weg, obwohl sie technisch noch
      steht. `visualViewport.offsetTop` gibt genau diese Verschiebung an.
      Setzt ausserdem das X ans untere Ende der Vorschau (dieselbe Rechnung).
    */
    function syncOffsets() {
      var el = $gallery.querySelector(VISIBLE_GALLERY);
      var aktiv = isSticky && !istAusgesetzt;
      var off = 0;
      if (aktiv && window.visualViewport) {
        off = Math.max(0, Math.round(window.visualViewport.offsetTop));
      }
      if (el) {
        if (aktiv) el.style.top = off + 'px';
        else el.style.removeProperty('top');
      }
      if (maskEl) maskEl.style.top = off + 'px';
      if (closeBtnEl && letzteOverlayHoehe) {
        closeBtnEl.style.top = (off + Math.max(8, Math.round(letzteOverlayHoehe) - 40)) + 'px';
      }
      /*
        Dem Browser sagen, dass die oberen X Pixel belegt sind. Ohne das scrollt er
        ein fokussiertes Eingabefeld zwar in den Viewport, aber unter unsere
        angedockte Vorschau - die Zeile, die der Kunde gerade tippt, ist dann weg.
      */
      document.documentElement.style.scrollPaddingTop =
        aktiv && letzteOverlayHoehe
          ? Math.round(letzteOverlayHoehe + ABSTAND_UNTER_VORSCHAU) + 'px'
          : '';
    }

    /*
      Sicherheitsnetz: Nicht jeder mobile Browser beachtet scroll-padding-top beim
      automatischen Scrollen zum fokussierten Feld. Deshalb nach dem Oeffnen der
      Tastatur nachmessen und bei Bedarf nach oben korrigieren.
    */
    function korrigiereScroll() {
      if (!fokussiertesFeld || !isSticky || istAusgesetzt) return;
      if (!document.contains(fokussiertesFeld)) return;
      var untereKanteVorschau = letzteOverlayHoehe + ABSTAND_UNTER_VORSCHAU;
      var r = fokussiertesFeld.getBoundingClientRect();
      if (r.top < untereKanteVorschau) {
        window.scrollBy(0, Math.round(r.top - untereKanteVorschau));
      }
    }

    /* Sichtbare Hoehe der fixierten Vorschau (getBoundingClientRect beruecksichtigt scale) */
    function getOverlayHeight() {
      var el = $gallery.querySelector(VISIBLE_GALLERY);
      return el ? el.getBoundingClientRect().height || 0 : 0;
    }

    /*
      Die Hoehe des Wrappers wird bewusst NICHT angefasst (anders als in der
      Vorlage): `#tee-gallery` traegt bereits eine feste Inline-Hoehe von
      TeeinBlue, es kann also nichts zusammenfallen, wenn die Vorschau aus dem
      Fluss genommen wird. Weniger Eingriff = weniger Nebenwirkungen.
    */
    function applyOverlayLayout() {
      var h = getOverlayHeight();
      if (h) updateMaskHeight(h);
    }

    function clearOverlayLayout() {
      updateMaskHeight(0);
    }

    function onScroll() {
      var currentY = window.scrollY || window.pageYOffset || 0;

      if (
        lastCheckScrollY !== null &&
        Math.abs(currentY - lastCheckScrollY) < SAFETY_SCROLLING_RANGE
      ) {
        if (isSticky) {
          var hNow = getOverlayHeight();
          if (hNow) updateMaskHeight(hNow);
        }
        return;
      }
      lastCheckScrollY = currentY;

      if (!$gallery.querySelector('#tee-gallery')) return;

      if (!hasStickyButton) {
        var openBtn = document.createElement('div');
        openBtn.className = 'sticky-gallery-button';
        openBtn.setAttribute('role', 'button');
        openBtn.setAttribute('aria-label', 'Vorschau wieder einblenden');
        openBtn.style.backgroundImage = ICON_OPEN;
        openBtn.addEventListener('click', function (e) {
          e.preventDefault();
          document.body.classList.remove('gallery--sticky--hide');
          window.requestAnimationFrame(applyOverlayLayout);
        });
        document.body.appendChild(openBtn);
        hasStickyButton = true;
        window.dispatchEvent(new Event('resize'));
      }

      if (!hasCloseButton) {
        var closeBtn = document.createElement('div');
        closeBtn.className = 'gallery--close-button';
        closeBtn.setAttribute('role', 'button');
        closeBtn.setAttribute('aria-label', 'Vorschau ausblenden');
        closeBtn.style.backgroundImage = ICON_CLOSE;
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          document.body.classList.add('gallery--sticky--hide');
          clearOverlayLayout();
        });
        document.body.appendChild(closeBtn);
        closeBtnEl = closeBtn;
        hasCloseButton = true;
      }

      var galleryBottom = $gallery.getBoundingClientRect().bottom;
      var formBottom = $form.getBoundingClientRect().bottom;

      if (galleryBottom < 0 && formBottom > stickyCondHeight && !isSticky) {
        document.body.classList.add('gallery--sticky');
        window.requestAnimationFrame(applyOverlayLayout);
        isSticky = true;
        window.dispatchEvent(new Event('resize'));
      }

      /*
        Solange ein Feld im Formular den Fokus hat, NICHT wegen `formBottom`
        abdocken: Beim Tippen scrollt der Browser das Eingabefeld ins Bild, die
        Unterkante des Formulars rutscht nach oben und die Bedingung schlaegt an -
        ausgerechnet in dem Moment, in dem der Kunde die Vorschau sehen will.
        `galleryBottom > 0` (Kunde ist zurueck bei der echten Galerie) loest
        weiterhin aus, sonst bliebe oben eine Leerflaeche stehen.
      */
      if (isSticky && ((formBottom < stickyCondHeight && !feldFokussiert) || galleryBottom > 0)) {
        document.body.classList.remove('gallery--sticky');
        clearOverlayLayout();
        isSticky = false;
        syncOffsets(); /* erst nach isSticky=false, sonst bleibt das inline `top` stehen */
        window.dispatchEvent(new Event('resize'));
      }
    }

    /*
      Aussetzen, solange TeeinBlue ein Overlay zeigt: Vorschau-Modal, Text
      verschieben/skalieren, Bild zuschneiden. TeeinBlue nutzt vue-js-modal und
      setzt dabei `vm--block-scroll` an <body> (am Live-Shop verifiziert);
      zusaetzlich prüfen wir auf einen sichtbaren Dialog-Container, falls eine
      Variante die Klasse nicht setzt.
    */
    function overlayOffen() {
      if (document.body.classList.contains('vm--block-scroll')) return true;
      var dialoge = document.querySelectorAll('.vm--container, .tee-edit-popup');
      for (var i = 0; i < dialoge.length; i++) {
        var r = dialoge[i].getBoundingClientRect();
        if (r.height > 0 && r.width > 0) return true;
      }
      return false;
    }

    function pruefeOverlay() {
      var offen = overlayOffen();
      if (offen === istAusgesetzt) return;
      istAusgesetzt = offen;
      document.body.classList.toggle('gallery--sticky--suspend', offen);
      /*
        Wichtig: das inline gesetzte `top` wieder entfernen. Sonst ueberschreibt
        unser Wert im ausgesetzten Zustand TeeinBlues eigenen Sticky-Abstand
        (`.tee-gallery { position: sticky; top: 15px }`).
      */
      syncOffsets();
      if (!offen && isSticky) {
        /* zurueck aus dem Overlay: Hinterlegung und X neu vermessen */
        window.requestAnimationFrame(applyOverlayLayout);
      }
    }

    new MutationObserver(pruefeOverlay).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true
    });
    pruefeOverlay();

    /* Fokus im Formular merken (steuert die Abdock-Sperre oben) */
    document.addEventListener('focusin', function (e) {
      if (!$form.contains(e.target)) return;
      feldFokussiert = true;
      fokussiertesFeld = e.target;
      /* Erst nach der Tastatur-Animation messen, sonst sind die Werte veraltet */
      setTimeout(korrigiereScroll, 350);
      setTimeout(korrigiereScroll, 700);
    });
    document.addEventListener('focusout', function (e) {
      if (!$form.contains(e.target)) return;
      feldFokussiert = false;
      fokussiertesFeld = null;
      /* Nach dem Schliessen der Tastatur neu bewerten, Drossel dabei umgehen */
      setTimeout(function () { lastCheckScrollY = null; onScroll(); syncOffsets(); }, 250);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      lastCheckScrollY = null; /* Viewport-Hoehe hat sich geaendert -> neu bewerten */
      onScroll();
      syncOffsets();
    }, { passive: true });
    if (window.visualViewport) {
      /* Tastatur auf/zu aendert die Groesse des sichtbaren Bereichs */
      window.visualViewport.addEventListener('resize', function () {
        syncOffsets();
        setTimeout(korrigiereScroll, 100);
      });
      window.visualViewport.addEventListener('scroll', syncOffsets);
    }
    onScroll();
  }

  function init() {
    /*
      Notausschalter: `?stickygallery=0` deaktiviert die Funktion fuer diesen
      Seitenaufruf. Damit laesst sich auf einem echten Geraet A/B testen (mit und
      ohne angedockte Vorschau), ohne dass etwas deployt werden muss - z. B. um
      zu klaeren, ob ein Darstellungsfehler von uns oder von TeeinBlue kommt.
    */
    if (window.location.search.indexOf('stickygallery=0') !== -1) return;
    if (TESTMODUS && window.location.search.indexOf('stickygallery=1') === -1) return;

    /* Nur Hochkant-Handys - identische Bedingung wie in der TeeinBlue-Anleitung */
    var w = window.innerWidth;
    var h = window.innerHeight;
    if (!(h / w > 1.5 && w < 768)) return;

    /* Auf TeeinBlue warten (Vue rendert asynchron), max. 20 s */
    var versuche = 0;
    var poll = setInterval(function () {
      var bereit =
        document.querySelector(GALLERY_WRAPPER + ' ' + VISIBLE_GALLERY) &&
        document.getElementById('tee-artwork-form');
      if (bereit) {
        clearInterval(poll);
        start();
      } else if (++versuche > 40) {
        clearInterval(poll);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
